import { Component, OnInit, Inject, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SharedService } from '../../services/shared.service';
import { GlobalService } from '../../services/global.service';
import { FirebaseService } from '../../service/firebase.service';

@Component({
  selector: 'app-progressbarmodal',
  templateUrl: './progressbarmodal.component.html',
  styleUrls: ['./progressbarmodal.component.scss']
})
export class ProgressbarmodalComponent implements OnInit, AfterViewInit {
  public multiple: boolean = false;
  public fileData: any;
  public showEndButton: boolean = false;
  constructor(public dialogRef: MatDialogRef<ProgressbarmodalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any, private _global: GlobalService, private _firebase: FirebaseService) {
    this.multiple = this.data.multiple
    this.fileData = this.data.fileData;
    this.dialogRef.disableClose = true;
  }


  //public percent: any;
  ngOnInit() {
   // console.log(this.multiple, this.fileData)
   /* this._global.uploadPercentObserver.subscribe((d) => {
      this.percent = d.toFixed(1);

      console.log("PERCENTAGE:", this.percent)
    })
    */

    this._firebase.multiUpload(this.fileData)
    this._global.allUploadPercentObserver.subscribe(d => {

      this.fileData = d;



      let end = true;

      this.fileData.forEach((item) => {
        if (item.downloaded != true)
          end = false;

      })

      if (end) {
        this.showEndButton = true;

      }

    })

  }

  ngAfterViewInit() {
    //console.log(this.fileData)

    let onlySizeError: boolean = false;


    this.fileData.forEach((item) => {
      if (!this.checkFileSize(item.data))
        onlySizeError = true;
    })


    if (onlySizeError)
      this.showEndButton = true;
  }

  closeModal() {
    this.close(this.fileData);
  }

  checkFileSize(data): boolean {
    let canUpload = true;
    if (data.type.includes('image') && data.size > 20971520) {
      canUpload = false;
    }
    else if (data.type.includes('video') && data.size > 2147483648) {
      canUpload = false;
    }

    return canUpload
  }

  truncPercent(percent) {
    return (Math.round(percent))
  }

  setItemData(item, val) {


    if (val) {
      this._firebase.getUrlFromPath(item.path).then(d => {
        item.url = d;
        item.downloaded = true;
        this._global.allUploadPercentObserver.next(this.fileData)
      });
    }
    else
      item.downloaded = true;


    item.selected = true;
  }

  close(data:any = null) {
    this.dialogRef.close(data);
  }

}
